import { gql } from '@apollo/client';

const GET_ADDRESS = gql`
  query getAddress($input: PositionToAddressInput!) {
    getPositionAddress(input: $input)
  }
`;

export { GET_ADDRESS };
